var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tag-sections" }, [
      _vm.organisationAreaEligible
        ? _c(
            "section",
            { staticClass: "tag" },
            [
              _c("h2", [
                _vm._v(
                  "\n\t\t\t\tAufgrund deiner Auswahl " +
                    _vm._s(_vm.organisationAreaTag) +
                    ":"
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tIn welchem Organisationsbereich möchtest du tätig sein?\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("OrganisationalArea", {
                staticClass: "mt-3",
                attrs: { "button-alignment": "left", functions: _vm.functions },
                on: { input: _vm.emitChangeEvent },
                model: {
                  value: _vm.organisationalArea,
                  callback: function($$v) {
                    _vm.organisationalArea = $$v
                  },
                  expression: "organisationalArea"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.industrialSectorEligible
        ? _c(
            "section",
            { staticClass: "tag" },
            [
              _c("h2", [_vm._v(_vm._s(_vm.industrialSectorTitle))]),
              _vm._v(" "),
              !_vm.industrialSectorsMandatory
                ? _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c("RadioGroup", {
                        attrs: {
                          options: _vm.industrialSectorsIrrelevantOptions
                        },
                        on: { input: _vm.industrialSectorsIrrelevantChanged },
                        model: {
                          value: _vm.industrialSectorsIrrelevant,
                          callback: function($$v) {
                            _vm.industrialSectorsIrrelevant = $$v
                          },
                          expression: "industrialSectorsIrrelevant"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.industrialSectorsIrrelevant === "no" ||
              _vm.industrialSectorsMandatory
                ? _c("IndustrialSectors", {
                    ref: "industrialSectors",
                    staticClass: "mt-3",
                    attrs: {
                      "button-alignment": "left",
                      "nothing-allowed": !_vm.industrialSectorsMandatory
                    },
                    on: { input: _vm.industrialSectorsChanged },
                    model: {
                      value: _vm.industrialSectors,
                      callback: function($$v) {
                        _vm.industrialSectors = $$v
                      },
                      expression: "industrialSectors"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.industrialSectorsMandatory &&
              _vm.industrialSectorsIrrelevant === "yes"
                ? _c("div", { staticClass: "mt-2" }, [
                    _vm._v(
                      "\n\t\t\t\tSei offen für alle Branchen. Du kannst deine Eingaben später noch in deinem Profil anpassen.\n\t\t\t"
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }